export const getEndUserTokenKeyByHandler = (handler) => `${handler}_endUserToken`;

const hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    return true;
};

export const SELF_FIELD_MAP = {
    fname:        (eu) => hasValue(eu?.fname),
    lname:        (eu) => hasValue(eu?.lname),
    phone:        (eu) => hasValue(eu?.phone),
    imageUrl:     (eu) => hasValue(eu?.imageUrl),
    birth_date:   (eu) => hasValue(eu?.birth_date),
    idOrPassport: (eu) => hasValue(eu?.idOrPassport),
    social_link:  (eu) => hasValue(eu?.social_link),
};

export function isSelfComplete(endUser, requiredFields) {
    if (!Array.isArray(requiredFields) || requiredFields.length === 0) return true;
    return requiredFields.every((field) => {
        if (typeof field !== 'string') return false;
        if (field.startsWith('dynamicFields.')) {
            const key = field.slice('dynamicFields.'.length);
            return hasValue(endUser?.dynamicFields?.[key]);
        }
        return SELF_FIELD_MAP[field]?.(endUser) ?? false;
    });
}
